'use client';

import { Container } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useLocale } from 'next-intl';
import { IconCard } from './icon-card/icon-card';
import css from './more-info-section.module.css';
function MoreInfo() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'channelpartners');
  return <Container width="sm" className={cn(css.container, 'md-pbe-64')} data-sentry-element="Container" data-sentry-component="MoreInfo" data-sentry-source-file="more-info-section.tsx">
            <SectionHeader title={t('info.title')} style={{
      '--section-mb': 0
    }} data-sentry-element="SectionHeader" data-sentry-source-file="more-info-section.tsx" />
            <IconCard.Grid data-sentry-element="unknown" data-sentry-source-file="more-info-section.tsx">
                <IconCard link={'/help/articles/todoist-partner-programs-t8t2hZ0Z'} title={t('info.questions.title')} subtitle={t('info.questions.link')} image="/static/channel-partners/more-info/questions.png" imageWidth={119} imageHeight={110} data-sentry-element="IconCard" data-sentry-source-file="more-info-section.tsx" />
                <IconCard link={'https://developer.todoist.com/submissions.html'} title={t('info.technical.title')} subtitle={t('info.technical.link')} image="/static/channel-partners/more-info/technical-partnership.png" data-sentry-element="IconCard" data-sentry-source-file="more-info-section.tsx" />
                <IconCard link={'/channelpartners/terms'} title={t('info.terms.title')} subtitle={t('info.terms.link')} image="/static/channel-partners/more-info/terms-of-services.png" imageWidth={119} imageHeight={110} data-sentry-element="IconCard" data-sentry-source-file="more-info-section.tsx" />
            </IconCard.Grid>
        </Container>;
}
export { MoreInfo };